// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.styles_button__NUSx0 {
  justify-content: center; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/FocusBoothButton/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,uBAAuB,EAAA","sourcesContent":["button.button {\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `styles_button__NUSx0`
};
export default ___CSS_LOADER_EXPORT___;
